import { defineComponent as _defineComponent } from 'vue';
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, unref as _unref, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createBlock as _createBlock, TransitionGroup as _TransitionGroup, withCtx as _withCtx, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-186c1286"), n = n(), _popScopeId(), n);
const _hoisted_1 = { class: "flex flex-col border border-gray-300 rounded-lg dark:bg-gray-600 dark:border-gray-500" };
const _hoisted_2 = { class: "flex flex-col pt-3 ml-6" };
const _hoisted_3 = { class: "text-xs text-gray-300 dark:text-gray-500" };
const _hoisted_4 = { class: "text-sm font-bold dark:text-gray-300" };
const _hoisted_5 = { class: "flex items-center justify-center flex-1 pt-3 mb-1 overflow-auto" };
const _hoisted_6 = {
    key: 0,
    class: "p-4 text-sm text-gray-300 dark:text-gray-500"
};
import componentI18n from '@/i18n/componentI18n';
const __default__ = {
    ...componentI18n('components.workspaces.selector')
};
import { computed, ref } from 'vue';
import { useStore } from 'vuex';
import { rejectInvitation } from '@/data/workspaces';
import ModalDialog from '@/components/ModalDialog.vue';
import SelectorItem from '@/components/workspaces/SelectorItem.vue';
import SelectorItemSkeleton from '@/components/workspaces/SelectorItemSkeleton.vue';
export default /*#__PURE__*/ _defineComponent({
    ...__default__,
    __name: 'Selector',
    props: {
        workspaces: null
    },
    setup(__props) {
        const props = __props;
        const displayableWorkspaces = ref(props.workspaces);
        const invitationToReject = ref(null);
        const store = useStore();
        const invitationName = computed(() => {
            return displayableWorkspaces.value.find((w) => w.invitationId === invitationToReject.value)?.name;
        });
        const noWorkspaces = computed(() => {
            return displayableWorkspaces.value.length === 0;
        });
        const email = computed(() => store.getters.session.email);
        const handleRemove = (invitationId) => {
            invitationToReject.value = invitationId;
        };
        const clearWorkspaceRemoval = () => {
            invitationToReject.value = null;
        };
        const removeWorkspace = async () => {
            const invitationId = invitationToReject.value;
            if (invitationId) {
                await rejectInvitation(invitationId);
                displayableWorkspaces.value = displayableWorkspaces.value.filter((w) => w.invitationId !== invitationId);
                clearWorkspaceRemoval();
            }
        };
        return (_ctx, _cache) => {
            const _component_transition_a11y = _resolveComponent("transition-a11y");
            return (_openBlock(), _createElementBlock("div", _hoisted_1, [
                _createElementVNode("div", _hoisted_2, [
                    _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.$t('logged_in')), 1),
                    _createElementVNode("h1", _hoisted_4, _toDisplayString(_unref(email)), 1)
                ]),
                _createElementVNode("div", _hoisted_5, [
                    _createVNode(_component_transition_a11y, {
                        css: false,
                        mode: "out-in"
                    }, {
                        default: _withCtx(() => [
                            (_unref(noWorkspaces))
                                ? (_openBlock(), _createElementBlock("p", _hoisted_6, _toDisplayString(_ctx.$t('no_workspaces')), 1))
                                : (_openBlock(), _createBlock(_TransitionGroup, {
                                    key: 1,
                                    name: "fade",
                                    tag: "ul",
                                    class: "w-full h-full"
                                }, {
                                    default: _withCtx(() => [
                                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(displayableWorkspaces.value, (workspace) => {
                                            return (_openBlock(), _createBlock(SelectorItem, {
                                                key: workspace.id,
                                                workspace: workspace,
                                                onRemove: ($event) => (workspace.invitationId && handleRemove(workspace.invitationId))
                                            }, null, 8, ["workspace", "onRemove"]));
                                        }), 128)),
                                        (!__props.workspaces)
                                            ? (_openBlock(), _createBlock(SelectorItemSkeleton, { key: "sk-1" }))
                                            : _createCommentVNode("", true),
                                        (!__props.workspaces)
                                            ? (_openBlock(), _createBlock(SelectorItemSkeleton, { key: "sk-2" }))
                                            : _createCommentVNode("", true)
                                    ], undefined, true),
                                    _: 1
                                }))
                        ], undefined, true),
                        _: 1
                    })
                ]),
                _createVNode(ModalDialog, {
                    centered: "",
                    "dismiss-action": clearWorkspaceRemoval,
                    "primary-actions": {
                        [_ctx.$t('modal.reject')]: removeWorkspace
                    },
                    "secondary-actions": { [_ctx.$t('modal.cancel')]: clearWorkspaceRemoval },
                    show: invitationToReject.value
                }, {
                    heading: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('modal.heading', { workspaceName: _unref(invitationName) })), 1)
                    ]),
                    after: _withCtx(() => [
                        _createTextVNode(_toDisplayString(_ctx.$t('modal.after')), 1)
                    ]),
                    _: 1
                }, 8, ["primary-actions", "secondary-actions", "show"])
            ]));
        };
    }
});
